'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = function (min) {
  return (0, _common.withParams)({ type: 'minValue', min: min }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/minValue.js
// module id = aYrh
// module chunks = 0